// extracted by mini-css-extract-plugin
export default {"subTab2CarrierUsers":"SubTab2_subTab2CarrierUsers__RXPNl","carrierUsersForm":"SubTab2_carrierUsersForm__oBEFW","light-purple-boxing":"SubTab2_light-purple-boxing__dwVnY"};